import Bhea from "../../src/imgs/company-logo/Bhea.svg";
import KuraKura from "../../src/imgs/company-logo/KuraKura.svg";

export const expData = [
  {
    position_name: "Associate Software Developer",
    company_name: "Bhea Technologies Pte. Ltd | Contract",
    date: "Aug 2024 - Nov 2024 | 4 mos",
    location: "Singapore | Remote",
    image: Bhea,
    tags: ["SugarCRM", "Marketing Automation", "Workflow Optimization"],
  },
  {
    position_name: "Software Engineer Intern",
    company_name: "Kura Kura | Internship",
    date: "Feb 2024 - Jun 2024 | 5 mos",
    location: "Singapore | Remote",
    image: KuraKura,
    tags: ["React Native", "Firebase", "Gamification"],
  },
];
